<script setup>
import { inject } from 'vue';

const search = inject('app-search', null);

if (!search) {
    throw new Error('app-search-bar-placeholder must be used within an app-search component');
}
</script>

<template>
    <button type="button" class="grow text-muted cursor-pointer text-left" :class="{ 'text-white-foreground': search.state.query }" @click="search?.openView()">
        {{ search.state.query || search.state.placeholder }}
    </button>
</template>
